{
  "title": "如何指派作品給評審",
  "description": "將已提交的作品批次指派給評審，開始評分流程。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，被指派的評審會在自己的評審工作區看到這些作品，可以開始評分。",
  "roleNote": "競賽管理員",
  "prerequisites": [
    "已建立評分規準（Rubric）並發布版本",
    "已邀請並確認評審身分",
    "作品已進入可評審階段"
  ],
  "pathLabel": "主辦方後台 → 我的競賽 → 評審邀請與指派 → 作品指派",
  "steps": [
    {
      "title": "1. 開啟「作品指派」分頁",
      "description": "進入指定競賽後，點選「評審邀請與指派」，切換到「作品指派」分頁。"
    },
    {
      "title": "2. 勾選作品與評審",
      "description": "支援批次勾選多件作品與多位評審，並選擇一個評分規準版本，一次為所有勾選的組合建立指派。也可以改用分頁最上方的「自動平均分配」：選輪次、評分規準與每件作品的評審人數，先預覽每位評審的工作量變化與無法補足的作品數，確認後才建立。"
    },
    {
      "title": "3. 送出批次指派",
      "description": "送出後系統會逐一嘗試建立每個「作品 × 評審」的組合；重複的指派（同一評審已指派同一作品）或有利益衝突的組合會被自動略過並回報原因，不會讓整批請求失敗。"
    },
    {
      "title": "4. 確認指派結果",
      "description": "畫面會顯示成功建立的指派清單，以及被略過的組合與原因（重複指派／利益衝突／該使用者非本競賽評審）。"
    }
  ],
  "afterward": [
    "成功指派的作品出現在對應評審的工作區",
    "略過的組合不會產生任何指派紀錄",
    "可在「評分進度」追蹤各評審的完成狀況"
  ],
  "nextSteps": "接著可以追蹤評分進度，掌握截止前是否有尚未完成的指派。",
  "faq": [
    {
      "q": "批次指派時部分組合失敗，其他組合會一起失敗嗎？",
      "a": "不會。系統會逐一略過重複或有利益衝突的組合並回報原因，不會因單一組合失敗而讓整批請求失敗；請依回報的原因個別處理。"
    },
    {
      "q": "可以事後修改單一指派的評審或評分規準版本嗎？",
      "a": "可以，針對狀態仍為「進行中」的單筆指派可以編輯；已有送出分數的指派通常不建議變更評分規準版本。"
    }
  ]
}
